export { Slider } from "./Slider";
export type { SliderBleed, SliderGap, SliderProps } from "./Slider.types";
